import React from "react";
const data = "lorem <b>ipsum</b>";

const DangerousHtml = () => {
  return <div dangerouslySetInnerHTML={{ __html: data }} />;
};

export default DangerousHtml;
